export const zoningLegendStyles = `
  .zoning-legend {
    position: absolute;
    bottom: 24px;
    left: 10px;
    background: rgba(255, 255, 255, 0.95);
    border-radius: 8px;
    padding: 10px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
    z-index: 100;
    font-size: 11px;
    display: none;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  }

  .zoning-legend.visible {
    display: block;
  }

  .zoning-legend-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 8px;
  }

  .zoning-legend-title {
    font-weight: 600;
    color: #1f2937;
  }

  .zoning-info-btn {
    width: 18px;
    height: 18px;
    border-radius: 50%;
    border: 1px solid #9ca3af;
    background: #f3f4f6;
    color: #6b7280;
    font-size: 11px;
    font-weight: 600;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    line-height: 1;
  }

  .zoning-info-btn:hover {
    background: #e5e7eb;
    border-color: #6b7280;
    color: #374151;
  }

  .zoning-legend-item {
    display: flex;
    align-items: center;
    margin: 4px 0;
    cursor: pointer;
    padding: 2px 4px;
    border-radius: 4px;
    transition: background-color 0.15s;
  }

  .zoning-legend-item:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }

  .zoning-legend-item input[type="checkbox"] {
    width: 14px;
    height: 14px;
    margin-right: 6px;
    cursor: pointer;
    accent-color: #16a34a;
  }

  .zoning-legend-item.disabled {
    opacity: 0.4;
  }

  .zoning-legend-item.disabled .zoning-legend-color {
    opacity: 0.3;
  }

  .zoning-legend-color {
    width: 16px;
    height: 16px;
    border-radius: 3px;
    margin-right: 8px;
    opacity: 0.7;
  }

  .zoning-legend-label {
    color: #374151;
  }

  /* Info popup */
  .zoning-info-popup {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: white;
    border-radius: 12px;
    padding: 20px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
    z-index: 1000;
    max-width: 400px;
    font-size: 13px;
  }

  .zoning-info-popup h3 {
    margin: 0 0 12px 0;
    font-size: 16px;
    color: #1f2937;
  }

  .zoning-info-popup p {
    margin: 8px 0;
    color: #4b5563;
    line-height: 1.5;
  }

  .zoning-info-table {
    width: 100%;
    border-collapse: collapse;
    margin: 12px 0;
  }

  .zoning-info-table th {
    text-align: left;
    font-size: 11px;
    font-weight: 600;
    color: #9ca3af;
    text-transform: uppercase;
    letter-spacing: 0.03em;
    padding: 0 6px 6px;
    border-bottom: 1px solid #e5e7eb;
  }

  .zoning-info-table td {
    padding: 8px 6px;
    border-bottom: 1px solid #f3f4f6;
    color: #4b5563;
    vertical-align: middle;
  }

  .zoning-info-table tr:last-child td {
    border-bottom: none;
  }

  .zoning-info-table td strong {
    color: #1f2937;
  }

  .zoning-info-table .category-color {
    width: 16px;
    height: 16px;
    border-radius: 4px;
  }

  .zoning-info-table .str-yes {
    color: #16a34a;
    font-weight: 600;
  }

  .zoning-info-table .str-no {
    color: #6b7280;
    font-weight: 600;
  }

  .zoning-info-table .str-tbd {
    color: #d97706;
    font-weight: 600;
  }

  .zoning-info-popup .minatoya-note {
    background: #fffbeb;
    border: 1px solid #fde68a;
    border-radius: 8px;
    padding: 10px 12px;
    font-size: 12px;
  }

  .zoning-info-popup .minatoya-note strong {
    color: #1f2937;
  }

  .zoning-info-popup .close-btn {
    position: absolute;
    top: 12px;
    right: 12px;
    width: 24px;
    height: 24px;
    border: none;
    background: #f3f4f6;
    border-radius: 50%;
    cursor: pointer;
    font-size: 16px;
    color: #6b7280;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .zoning-info-popup .close-btn:hover {
    background: #e5e7eb;
    color: #374151;
  }

  .zoning-info-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 999;
  }
`;
//# sourceMappingURL=styles.js.map